// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__QQkOq","legacyBtn":"MutateMid_legacyBtn__1cCae"};